import { Tag } from '@components';
import { Box, IconButton, Typography, useTheme, capitalize } from '@mui/material';
import { Add, Buildings, Location } from 'iconsax-react';
import type { FC } from 'react';

import type Enums from '@core/types/api/Enums';
import { hasValue } from '@core/utils/equality';
import { SlabCard } from '@web/components/SlabCard/SlabCard';

import { MatchChip } from './MatchChip';

type Props = {
  customerInfo: {
    integrationType?: Enums.IntegrationType | null;
    dispatchCustomerName: string;
    address?: string | null;
    matchStrength?: string;
  };
  onClose?: () => void;
};

export const CustomerInfo: FC<Props> = ({ customerInfo, onClose }) => {
  const theme = useTheme();
  return (
    <SlabCard
      sx={{
        padding: 1.5,
        gap: 2,
        my: 0,
        position: 'relative',
        flex: 1,
      }}
    >
      {onClose && (
        <IconButton
          size='small'
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: theme.palette.SlabIndigo[700],
            transform: 'rotate(45deg)',
          }}
          onClick={onClose}
        >
          <Add size={24} variant='TwoTone' />
        </IconButton>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {hasValue(customerInfo.integrationType) && (
          <Tag
            variant='Secondary'
            label={capitalize(customerInfo.integrationType)}
            icon={Buildings}
            iconColor={theme.palette.SlabIndigo[700]}
          />
        )}
        {hasValue(customerInfo.matchStrength) && (
          <MatchChip matchStrength={customerInfo.matchStrength} />
        )}
      </Box>

      <Typography variant='h6' sx={{ lineHeight: 1.2 }}>
        {customerInfo.dispatchCustomerName}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {hasValue(customerInfo.address) && (
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <Location
              style={{ flexShrink: 0, top: 3, position: 'relative' }}
              size={16}
              variant='TwoTone'
              color={theme.palette.SlabIndigo[700]}
            />
            <Typography variant='body2' sx={{ lineHeight: 1.2 }}>
              {customerInfo.address}
            </Typography>
          </Box>
        )}
      </Box>
    </SlabCard>
  );
};
